/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingpricelevelnone3Inputs */

const en_listingpricelevelnone3 = /** @type {(inputs: Listingpricelevelnone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not stated`)
};

const de_listingpricelevelnone3 = /** @type {(inputs: Listingpricelevelnone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Angabe`)
};

/**
* | output |
* | --- |
* | "Not stated" |
*
* @param {Listingpricelevelnone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingpricelevelnone3 = /** @type {((inputs?: Listingpricelevelnone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingpricelevelnone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingpricelevelnone3(inputs)
	return de_listingpricelevelnone3(inputs)
});
export { listingpricelevelnone3 as "listingPriceLevelNone" }